import React, { useState, useEffect, useRef } from "react";
import {
    Col,
    Label,
    Row,
    Form,
    Button,
    Spinner,
    FormGroup,
} from "reactstrap";
import { post, get } from "../../../Services/RestAPIService";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./SelectTime.css"; // Import your CSS file for styling

const SelectTime = ({ OnSubmit, Response, Data, Alerts, Loading }) => {
    const animatedComponents = makeAnimated();
    const [timeSlots, setTimeSlots] = useState([]);
    const [timeSlotsSelected, setTimeSlotsSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [excludedWeekdays, setExcludedWeekdays] = useState([]);
    const navigate = useNavigate();
    const monthListRef = useRef(null);
    const dateListRef = useRef(null);

    const getTimeSlots = async () => {
        try {
            const response = await get(`appoint/times/`);
            const data = response.results;

            // Create a map to group time slots by their label
            const groupedTimeSlots = data.reduce((acc, slot) => {
                if (!acc[slot.label]) {
                    acc[slot.label] = [];
                }
                acc[slot.label].push({
                    label: slot.time,
                    value: slot.id // Convert id to string if needed
                });
                return acc;
            }, {});

            // Format the grouped data into the structure you need
            const formattedTimeData = Object.keys(groupedTimeSlots).map(label => ({
                label: "Available Time Data",
                category: label,
                options: groupedTimeSlots[label]
            }));

            // Set the formatted data to state
            setTimeSlots(formattedTimeData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        getTimeSlots();
    }, []);

    useEffect(() => {
        getSelectedTime();
    }, [selectedDate]);

    const daysBetween = (startDate, endDate) => {
        const date1 = new Date(startDate);
        const date2 = new Date(endDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
    };


    const getSelectedTime = async () => {
        setIsLoading(true)
        setTimeSlotsSelected(null);
        const formattedDate = `${selectedDate.getFullYear()}-${('0' + (selectedDate.getMonth() + 1)).slice(-2)}-${('0' + selectedDate.getDate()).slice(-2)}`;
        try {
            const data = await get(`appoint/timeslot/?doctor=${Data}&date=${formattedDate}`);
            // setUserData(data);
            console.log(data, "Timedata")
            const ExerciseData = data?.results[0]?.time
            let formattedData

            if (ExerciseData) {
                formattedData = ExerciseData.map((time) => ({
                    label: time.time,
                    value: time.id.toString(),
                }));
            }
            console.log("selectedExercises:", formattedData);
            setTimeout(() => {
                setTimeSlotsSelected(formattedData);
                setIsLoading(false)
            }, 1000);


            // Uncomment this line to set the state
        } catch (error) {
            console.error("Please Create Slots For this Date", error);

        } finally {
            setIsLoading(false);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const formattedDate = `${selectedDate.getFullYear()}-${('0' + (selectedDate.getMonth() + 1)).slice(-2)}-${('0' + selectedDate.getDate()).slice(-2)}`;

        const TimeIds = timeSlotsSelected.map((time) => time.value);

        const formData = {
            "date": formattedDate,
            "doctor": parseFloat(Data),
            "time": TimeIds
        };
        console.log(formData, "formdata")
        try {
            const response = await post("appoint/timeslot/", formData);
            if (response.status <= 399) {
                Alerts({
                    color: "success",
                    visible: true,
                    message: "Timings submitted successfully.",
                    strongM: "Success!",
                });

                // Response(3)
                // Navigate to the next step if applicable
                // navigate('/next-step');
            } else {
                Alerts({
                    color: "danger",
                    visible: true,
                    message: "An error occurred.",
                    strongM: "Error!",
                });
            }
            console.log(response, "response")
        } catch (error) {
            console.error('Error submitting categories:', error);
            Alerts({
                color: "danger",
                visible: true,
                message: "An error occurred.",
                strongM: "Error!",
            });
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <React.Fragment>
            <Form id="SubmitEditTime" onSubmit={handleSubmit}>
                <Col lg="6">
                    <Label className="control-label">
                        {Data === null
                            ? "Please Register Consultent fot this Step"
                            : `Consultent is Registered with us and its Id is: ${Data}`}
                    </Label>


                    <FormGroup className="mb-3">
                        {/* Date picker for selecting start date */}
                        <Label className="control-label">Select Date</Label>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            minDate={new Date()}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </FormGroup>


                    {selectedDate && (
                        <FormGroup className="mb-3 templating-select select2-container">
                            {/* Your select time component */}
                            <Label className="control-label">
                                Please Select Time you are Available in a Day. (Time Slots Selected:{" "}
                                {timeSlotsSelected?.length})
                            </Label>

                            <Select
                                value={timeSlotsSelected}
                                isMulti={true}
                                onChange={(selectedOptions) => setTimeSlotsSelected(selectedOptions)}
                                options={timeSlots}
                                classNamePrefix="select2-selection"
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isLoading={isLoading}
                            />
                        </FormGroup>)}


                    {selectedDate && (<Button type="submit" form="SubmitEditTime" color="primary" disabled={isLoading}>
                        {isLoading ? <Spinner size="sm" color="gray" /> : "Submit"}
                    </Button>)}



                </Col>
            </Form>
        </React.Fragment>
    );
};

export default SelectTime;
